import { useIsLoggedInWithLoading } from '@dreamstack/auth'
import { CapitalInvestmentOrderGuideForm } from '@dreamstack/feature-components/src/capitalInvestmentGuide/CapitalInvestmentOrderGuideForm'
import Skeleton from '@mui/material/Skeleton'
import type { FunctionComponent } from 'react'

export const CapitalInvestmentGuideOrderForm: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const { loading, isLoggedIn } = useIsLoggedInWithLoading()
  return (
    <>
      <div className="col-span-full">
        {loading ? (
          <div className="flex flex-col justify-start">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="w-full" height={184} />
            ))}
          </div>
        ) : (
          <CapitalInvestmentOrderGuideForm />
        )}
      </div>
    </>
  )
}
